import { render, staticRenderFns } from "./JuournalComponent.vue?vue&type=template&id=bcb88e74&"
import script from "./JuournalComponent.vue?vue&type=script&lang=js&"
export * from "./JuournalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports